import React from 'react';

const ZoomOutIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    "
    <ellipse
      cx="9.0386"
      cy="9.22046"
      rx="5.82668"
      ry="5.88495"
      stroke="#1F221F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.4167 16.674L13.1562 13.3809"
      stroke="#1F221F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M6.80005 9.14996H11.1" stroke="#1F221F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ZoomOutIcon;
